// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_3q-0";
export var eligibilityCardNotEligible = "_3q-1";